<template>
  <!-- 询比文件 -->
  <upload-authorization-file
    ref="uploadFile"
    v-model="fileGroupIdCopy"
    style="width:700px"
    :preview-api="previewApi"
    :download-api="downloadApi"
    :translate-data="{
      downloadTranslate: 'fileUrl'
    }"
    :props-data="{
      disabled: readOnly,
      bizType: 'inquiry_order',
      attachmentType: 'inquiry_attachment'
    }"
    :request-params="{
      fileGroupId: fileGroupIdCopy,
      orderId: orderId,
      tradeId: tradeId,
      isRelease: isRelease,
      fileType: 1
    }"
  />
</template>

<script>
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile'

// 后端api
import { downloadpurchaserInquiryFileApi, previewpurchaserInquiryFileApi } from '@/api/procure/inquiry'

export default {
  components: {
    UploadAuthorizationFile
  },

  model: {
    prop: 'fileGroupId',
    event: 'change'
  },

  props: {
    fileGroupId: {
      type: [Number, String],
      default: ''
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 项目id
    orderId: {
      type: [Number, String],
      default: 0
    },
    tradeId: {
      type: [String, Number],
      default: ''
    },
    // 文件是否已发布
    isRelease: {
      type: Boolean,
      default: undefined
    },
    previewApi: {
      type: Function,
      default: previewpurchaserInquiryFileApi
    },
    downloadApi: {
      type: Function,
      default: downloadpurchaserInquiryFileApi
    }
  },

  data() {
    return {
      downloadpurchaserInquiryFileApi,
      previewpurchaserInquiryFileApi
    }
  },

  computed: {
    fileGroupIdCopy: {
      get() {
        return this.fileGroupId
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
